import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {MatchLineupTabComponent} from '@modules/game-detail/pages/match-lineup-tab/match-lineup-tab.component';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {GameDetailRouting} from '@modules/game-detail/game-detail.routing';
import {MatchDetailWrapperComponent} from '@modules/game-detail/pages/match-detail-wrapper/match-detail-wrapper.component';
import {MatchLiveTickerActivityComponent} from '@modules/game-detail/pages/match-live-ticker-activity/match-live-ticker-activity.component';
import {MatchLiveTickerTabComponent} from '@modules/game-detail/pages/match-live-ticker-tab/match-live-ticker-tab.component';
import {MatchDetailSelectTeamDialogComponent} from '@modules/game-detail/dialogs/match-detail-select-team-dialog/match-detail-select-team-dialog.component';
import {MatchVideosTabComponent} from '@modules/game-detail/pages/match-videos-tab/match-videos-tab.component';
import {MatchOverviewTabComponent} from '@modules/game-detail/pages/match-overview-tab/match-overview-tab.component';
import {MatchLineupPlayerComponent} from '@modules/game-detail/pages/match-lineup-tab/match-lineup-player/match-lineup-player.component';
import {DesktopReporterMatchesCardComponent} from '@modules/game-detail/components/desktop-reporter-matches-card/desktop-reporter-matches-card.component';
import {SharedPipesModule} from '@shared/pipes/pipes.module';
import {LibUtilsPipesModule} from '@utils/pipes/lib-utils-pipes.module';
import {InViewportModule} from 'ng-in-viewport';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import {SharedGamesModule} from '@shared/modules/shared-games/shared-games.module';
import {LibAdCampaignModule} from '@components/ad-campaign/lib-ad-campaign.module';
import {LibVideoPlayerModule} from '@components/video-player/lib-video-player.module';
import {LibBettingGameModule} from '@components/betting-game/lib-betting-game.module';
import { MatchScoreHeaderComponent } from './components/match-score-header/match-score-header.component';
import { MatchVideoHeaderComponent } from './components/match-video-header/match-video-header.component';

@NgModule({
  imports: [
    CommonModule,
    GameDetailRouting,
    SharedModule,
    SharedPipesModule,
    InViewportModule,
    SharedGamesModule,
    LibTableModule,
    LibAdCampaignModule,
    LibVideoPlayerModule,
    LibUtilsPipesModule,
    LibBettingGameModule,
  ],
  declarations: [
    MatchDetailWrapperComponent,
    MatchLiveTickerActivityComponent,
    MatchLiveTickerTabComponent,
    MatchDetailSelectTeamDialogComponent,
    MatchVideosTabComponent,
    MatchOverviewTabComponent,
    MatchLineupTabComponent,
    MatchLineupPlayerComponent,
    DesktopReporterMatchesCardComponent,
    MatchScoreHeaderComponent,
    MatchVideoHeaderComponent
  ],
  providers: [
    MatchDetailViewService,
  ]
})
export class GameDetailModule { }
